import React from 'react'
import clsx from "clsx";
import {
    Container,
    UnderlineTextButton,
    PrimaryButton,
    DeleteButton,
} from "./FullscreenModal.styles";
import TopBarRedesigned from "../TopBarRedesigned/TopBarRedesigned";

interface GreenCheckmarkWithTextProps {
    isOpen: boolean,
    isNoBackArrow?: boolean,
    title: string,
    buttonText?: string,
    children?: React.ReactNode,
    onClose: () => void,
    onSubmit: (e: any) => void,
    onDelete?: () => void,
    submitRef?: any,
    stickyBottom?: boolean,
    disabledSubmit?: boolean,
    underlinedButtonText?: string,
    onUnderlinedClick?: () => void,
    deleteButtonText?: string,
    isSignUpPage?: boolean,
    hideNotificationBell?: boolean,
    useStandardBack?: boolean,
    coverViewport?: boolean,
    /** T2-6717: leave room for TalentNavbar (bell + hamburger) above the modal */
    reserveTopNav?: boolean,
}

const FullscreenModal = ({title, buttonText, children, onClose, onSubmit, isOpen, isNoBackArrow=false, submitRef, stickyBottom = true, disabledSubmit, underlinedButtonText, onUnderlinedClick, deleteButtonText, onDelete, isSignUpPage=false, hideNotificationBell=false, useStandardBack=false, coverViewport=false, reserveTopNav=false}: GreenCheckmarkWithTextProps) => {
    return (
        <Container
            id="fsModal"
            style={{display: isOpen ? 'flex' : 'none'}}
            onSubmit={onSubmit}
            isSignUpPage={isSignUpPage}
            coverViewport={coverViewport}
            reserveTopNav={reserveTopNav}
        >
            <TopBarRedesigned isNoBackArrow={isNoBackArrow} onBack={onClose} title={title} hideNotificationBell={hideNotificationBell} useStandardBack={useStandardBack} />
            <div className={clsx('modalBody', stickyBottom ? 'marginBody' : '' )}>{children}</div>
            <div className={clsx('modalFooter', stickyBottom ? 'stickyBottom' : '')}>
                {buttonText && <PrimaryButton
                    disabled={disabledSubmit}
                    ref={submitRef}
                    type={"submit"}
                    variant="contained"
                    color="primary"
                    size="large"
                    id="signup-button"
                    className={clsx("submitButton", "no-fastclick")}
                >
                    {buttonText}
                </PrimaryButton>}
                {deleteButtonText && <DeleteButton
                    variant="outlined"
                    color="primary"
                    size="small"
                    id="signup-button"
                    className="no-fastclick"
                    onClick={onDelete}
                >
                    {deleteButtonText}
                </DeleteButton>}
                {underlinedButtonText && <UnderlineTextButton
                    className={'onCloseBtn'}
                    variant="text"
                    color="primary"
                    size="large"
                    onClick={onUnderlinedClick || onClose}
                >
                    {underlinedButtonText}
                </UnderlineTextButton>}
            </div>
        </Container>
    )
}

export default FullscreenModal
